import {
  FETCH_PAYMENTS,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_ERROR,
} from './constants';

export const paymentsInitialState = {
  isFetching: true,
  isEmpty: false,
  totalBalance: 0,
  error: null,
};

const payments = (state = paymentsInitialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS:
      return {
        ...state.payments,
        isFetching: true,
      };

    case FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        totalBalance: action.data.totalBalanceChange,
        isFetching: false,
        list: action.data,
        isEmpty: !action.data,
        error: null,
      };

    case FETCH_PAYMENTS_ERROR:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default payments;
